<template>
  <div
    v-if="!isConfirmCookie"
    class="vz-cookies"
  >
    <div class="vz-cookies-content">
      <div class="vz-cookies-content-description">
        Для обеспечения функциональности сайта используем файлы куки.
        <div>
          <a
            target="_blank"
            href="/cookie.pdf"
            download
          >
            Подробнее
          </a>
        </div>
      </div>

      <div
        class="vz-cookies-content-button"
        @click="acceptCookies"
      >
        Принять
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";

const isConfirmCookie = ref(document?.cookie.includes('_vz_confirm_cookie') || null)

function setCookie(name, value, options = {}) {
  if (!document) {
    return
  }

  options = {
    path: '/',
    // при необходимости добавьте другие значения по умолчанию
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

function acceptCookies() {
  if (!isConfirmCookie.value) {
    isConfirmCookie.value = true
    setCookie('_vz_confirm_cookie', true, {expires: new Date('2040-01-01').toUTCString()})
  }
}
</script>

<style>
.vz-cookies {
  display: flex;
  z-index: 2050;
  justify-content: center;
  background: #657d95;
  padding: 20px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
}

.vz-cookies-content {
  width: 907px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vz-cookies-content-description {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 4px;
  font-size: 16px;
  color: #fff;
}

.vz-cookies-content-description a {
  text-decoration: underline;
  color: #d9dcde;
}

.vz-cookies-content-button {
  cursor: pointer;
  color: #657d95;
  width: 161px;
  justify-content: center;
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  border-radius: 4px;
  transition: background 150ms ease-in-out;
}

.vz-cookies-content-button:hover {
  background-color: #b8cadc !important;
  border-color: transparent !important;
  color: #333 !important;
  text-decoration: unset;
}

@media screen and (max-width: 1087px) {
  .vz-cookies-content {
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 0 10px;
  }
  .vz-cookies-content-description {
    justify-content: center;
    text-align: center;
  }
}
</style>
